import { CustomDetailEnum } from '@dealstack/shared/lib/generated/models/CustomDetailEnum.ts';

/**
 * "Other details" should always include INDIVIDUAL fields, and include VEHICLE fields
 * only when the current investment is made via a PIV.
 */
export const shouldIncludeInOtherDetails = (type: CustomDetailEnum, isPIVInvestment: boolean) =>
	type === CustomDetailEnum.INDIVIDUAL || (isPIVInvestment && type === CustomDetailEnum.VEHICLE);
